import React, { useState } from 'react';
import { Collapse, Divider, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { Report } from 'api/types/types';
import { useTranslation } from 'react-i18next';

interface Props {
    category: string;
    reports: Report[];
    currentReportId: string;
    setCurrentReportId: (id: string) => void;
}

export default function CategorizedReportList(props: Props) {
    const [open, setOpen] = useState(true);
    const { t } = useTranslation(['reports']);
    const { category, reports, currentReportId, setCurrentReportId } = props;

    return (
        <>
            <ListItem style={{ padding: '14px 10px' }} button={true} onClick={() => setOpen((o) => !o)}>
                <ListItemText>
                    <Typography variant="h6" style={{ fontSize: '1rem', fontWeight: 500 }}>
                        {category || t('list.category.empty')}
                    </Typography>
                </ListItemText>
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Divider />
            <Collapse in={open} timeout="auto" unmountOnExit={true}>
                {reports.map((report) => {
                    return (
                        <List
                            key={report.id}
                            disablePadding={true}
                        >
                            <ListItem
                                button={true}
                                style={{ 
                                    padding: '14px 14px 14px 28px'
                                }}
                                onClick={() => setCurrentReportId(report.reportId)}
                                selected={report.reportId === currentReportId}
                            >
                                <div>
                                    <Typography>{report.name}</Typography>
                                </div>
                            </ListItem>
                        </List>
                    );
                })}
            </Collapse>
        </>
    );
}
